<template>
  <section>
    <div class="noScroll">
      <social-header v-if="currentEnv" title="活动详情"></social-header>
      <share v-bind:title="activity.activityCustomerName" v-bind:link="wxMiniLink"
        v-bind:imgUrl="activity.shareImageUrl" v-bind:desc="activity.activityRemark" v-bind:type="activity.activityType"
        v-bind:show="isShowShareWindow" v-bind:platformActivityId="activity.platformActivityId"
        v-bind:businessLineId="activity.businessLineId" ref="share"></share>
      <share-panel ref="sharePanel" @sharePanelClick="sharePanelClick" />
      <!--首页轮播图-->
      <div class="index-banner">
        <ul>
          <li>
            <img v-bind:src="activity.activityPic" alt />
          </li>
        </ul>
        <!-- <p class="index-banner-dot"><span  class="current"></span><span></span><span></span></p> -->
      </div>
      <!--首页轮播图-->
      <!--车型名称-->
      <div class="act-detail-name">
        <p>{{ activity.activityName }}</p>
        <a title v-stat:click="{ name: 'detail' }" v-debounce="participate">
          <span v-if="
            activity.businessLineId == 1501 || activity.businessLineId == 1801
          ">
            自购车
          </span>
          <span v-else>
            参与
            <br />活动
          </span>
          <em class="iconfont_M icon-more_M"></em>
        </a>
      </div>
      <!--车型名称-->
      <!--活动说明-->
      <div class="act-detail-intro">
        <div class="dlr-title">
          <span>活动规则</span>
        </div>
        <div class="act-detail-role">
          <dl class="clearfix">
            <dt class="act-detail-tag">活动介绍：</dt>
            <dd class="act-detail-role-content">
              {{ activity.activityRemark }}
            </dd>
          </dl>
          <dl class="clearfix" v-show="activity.activityDetail">
            <dt class="act-detail-tag">活动详情：</dt>
          </dl>
          <dl class="clearfix" v-show="activity.activityDetail">
            <div v-html="activity.activityDetail" class="act-detail-html"></div>
          </dl>
          <dl class="clearfix">
            <dt class="act-detail-tag">活动日期：</dt>
            <dd class="act-detail-role-content">
              {{ activity.activityStartTimeStr }} -
              {{ activity.activityEndTimeStr }}
            </dd>
          </dl>
          <dl class="clearfix">
            <dt class="act-detail-tag">奖励规则：</dt>
            <dd class="act-detail-role-content" v-if="activity.businessLineId !== 402"
              v-html="activity.commissionRules"></dd>
            <dd class="act-detail-role-content" v-if="activity.businessLineId === 402">
              <template v-for="(item3, index) in activity.commissionList">
                <template v-if="item3.nodeId == 450 && parseFloat(item3.amount) > 0">
                  {{ item3.amountType === 0 ? item3.nodeName : "返佣高达保费" }}
                  <span class="font-red" :key="item3.nodeName">{{
                    item3.amount.toFixed(2)
                  }}</span>
                  {{ item3.amountType === 0 ? "元" : "%"
                  }}{{
                    index === activity.commissionList.length - 1 ? "" : "，"
                  }}
                </template>
              </template>
            </dd>
          </dl>
          <dl class="clearfix">
            <dt class="act-detail-tag" id="act-detail-area-title">
              活动地区：
            </dt>
            <dd class="act-detail-role-content">
              <div class="act-detail-role-addr" v-bind:class="{ height100: !isShowAllAreaUp }">
                <p id="act-detail-area-con">
                  {{
                    activity.areaCityJoinStr ? activity.areaCityJoinStr : "全国"
                  }}
                </p>
              </div>
              <p class="act-detail-role-more" v-bind:class="{ up: isShowAllAreaUp }" v-show="isShowAllArea"
                v-on:click="isShowAllAreaUp = !isShowAllAreaUp">
                <em class="iconfont_M icon-more_M"></em>
              </p>
            </dd>
          </dl>
        </div>
      </div>
      <!--活动说明-->
      <!-- 常见问题说明 -->
      <div class="question-desc" v-show="columnList && columnList.length !== 0">
        <img @click="toQuestionColumn" src="../../static/img/question_banner.png" alt="常见问题说明" />
      </div>
      <!-- 常见问题说明 -->
      <!--分享操作说明-->
      <div v-if="isShowShare" class="act-detail-share">
        <div class="dlr-title">
          <span>分享操作说明</span>
        </div>
        <div class="act-detail-img">
          <img src="../../static/img/act-detail-share.png" alt />
        </div>
      </div>
      <!--分享操作说明-->
      <!--底部按钮-->
      <div v-if="isShowShare" class="act-detail-btn-bak"></div>
      <div v-if="isShowShare" class="act-detail-btn" v-stat:click="{
        name: 'share_' + platformActivityId,
        actid: platformActivityId,
      }">
        <a href="javascript:;" title v-on:click="shareClick">分享赚奖励</a>
      </div>

      <!-- 展示海报 -->
      <div v-show="isShowPoster" class="poster">
        <div class="header">
          <div class="left"></div>
          <div class="title" @click="savePosterImg">
            {{ entrance == "lk" || isAnb() ? "分享赚奖励" : "长按保存图片" }}
          </div>
          <div class="close" @click="closePoster">
            <img src="../../static/img/close.png" alt="" />
            <!-- <i class="iconfont icon-guanbi"></i> -->
          </div>
        </div>
        <div class="copy">
          <div class="left" v-if="imgss.length > 0" v-html="imgss[activeIndex].imageContent" ref="aa"></div>
          <div class="left" v-else>2</div>
          <div class="right" @click="copyText">
            <div class="copys">
              <img src="../../static/img/copy.png" alt="" />
              <p>复制</p>
            </div>
          </div>
        </div>
        <div class="swiper">
          <div class="swiper-container" :class="{ 'swiper-container-padBot': entrance != 'lk' }">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in imgs" :key="index">
                <img :src="item" alt="" />
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
        <div v-show="entrance == 'lk'" class="menu-list">
          <div class="menu-item" @click="savePosterImg">
            <div class="menu-icon">
              <img src="../../static/img/save.png" alt="" />
            </div>
            <div class="menu-text">保存本地</div>
          </div>
          <div class="menu-item" @click="shareByPicture">
            <div class="menu-icon">
              <img src="../../static/img/wx.png" alt="" />
            </div>
            <div class="menu-text">微信分享</div>
          </div>
          <div class="menu-item" @click="saveActivityUrl">
            <div class="menu-icon">
              <img src="../../static/img/copyz.png" alt="" />
            </div>
            <div class="menu-text">复制链接</div>
          </div>
        </div>
        <div v-show="isAnb()" class="menu-list">
          <div class="menu-item" @click="savImg">
            <div class="menu-icon">
              <img src="../../static/img/save.png" alt="" />
            </div>
            <div class="menu-text">保存本地</div>
          </div>
          <div class="menu-item" @click="shareAnbWX">
            <div class="menu-icon">
              <img src="../../static/img/wx.png" alt="" />
            </div>
            <div class="menu-text">微信分享</div>
          </div>
          <div class="menu-item" @click="savUrl">
            <div class="menu-icon">
              <img src="../../static/img/copyz.png" alt="" />
            </div>
            <div class="menu-text">复制链接</div>
          </div>
        </div>
        <div v-show="entrance == 'mainapp'" class="menu-list">
          <div class="menu-item" @click="mainShareByWX">
            <div class="menu-icon">
              <img src="../../static/img/shareWX.png" alt="" />
            </div>
            <div class="menu-text">微信分享</div>
          </div>
          <div v-show="imgs.length > 0" class="menu-item" @click="mainShareByPYQ">
            <div class="menu-icon">
              <img src="../../static/img/sharePYQ.png" alt="" />
            </div>
            <div class="menu-text">朋友圈</div>
          </div>
        </div>
      </div>

      <!-- 展示分享UI -->
      <div v-show="isShowShareUI && entrance == 'lk'" class="share-ui">
        <div class="menu-list">
          <div class="menu-item" @click="shareByWX">
            <img src="../../static/img/shareWX.png" alt="" />
            <div class="text">微信</div>
          </div>
          <div class="menu-item" @click="shareByPYQ">
            <img src="../../static/img/sharePYQ.png" alt="" />
            <div class="text">朋友圈</div>
          </div>
        </div>
        <div class="exit" @click="closePoster">取消</div>
      </div>
      <div v-show="isShowShareUI && isAnb()" class="share-ui">
        <div class="menu-list">
          <div class="menu-item" @click="shareAnbWX">
            <img src="../../static/img/shareWX.png" alt="" />
            <div class="text">微信</div>
          </div>
          <div class="menu-item" @click="shareAnbPYQ">
            <img src="../../static/img/sharePYQ.png" alt="" />
            <div class="text">朋友圈</div>
          </div>
        </div>
        <div class="exit" @click="closePoster">取消</div>
      </div>
      <div v-show="isShowShareUI && entrance == 'mainapp'" class="share-ui">
        <div class="menu-list">
          <div class="menu-item" @click="mainShareByWX">
            <img src="../../static/img/shareWX.png" alt="" />
            <div class="text">微信</div>
          </div>
        </div>
        <div class="exit" @click="closePoster">取消</div>
      </div>
      <div v-show="isShowMask" @click="closePoster" class="mask"></div>
      <div class="masks" v-show="masks">{{ tipText }}</div>
      <!--底部按钮-->
      <social-dialog v-bind:title="loadingText" category="tips" v-bind:show="dialogShow"></social-dialog>
      <div class="wrapper" v-show="show">
        <div class="block">
          <div class="login">信息补充</div>
          <div class="centent">
            <p>根据业务要求，请补充如下信息以便正常使用产品功能</p>
          </div>
          <div class="UM" v-if="isname">
            <input type="text" placeholder="请输入姓名" v-model="complementUserName" class="input" />
          </div>
          <div class="UM" v-if="iscode">
            <input type="text" placeholder="请输入工号" v-model="complementAgentNo" class="input" />
          </div>
          <div class="submit" @click="submitComp">提交信息</div>
          <img src="../../static/img/小白@3x.png" @click="show = false" class="img" alt="" />
        </div>
      </div>
      <div class="wrapper" v-show="showFile">
        <div class="block">
          <div class="login">温馨提示</div>
          <div class="centent">
            <p>{{ fileMessage }}</p>
          </div>
          <div class="submit" @click="fileClick">我知道了</div>
          <img src="../../static/img/小白@3x.png" @click="showFile = false" class="img" alt="" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import Swiper from "swiper";
// import 'swiper/css/swiper.min.css';
import "swiper/dist/css/swiper.css";
import userApi from "../../api/user";
import SocialHeader from "../../components/social-header.vue";
import SocialDialog from "../../components/social-dialog.vue";
import PullLoad from "../../components/pull-load.vue";
import Share from "../../components/share.vue";
import SharePanel from "../../components/share-panel.vue";
import Dialog from "../../plugins/dialog.js";
import Tools from "../../tools/tools.js";
import { isGoEnv } from "../../service/vaildGo.service";
import {
  isWeiXin,
  isDingDing,
  changeDocumentTitle,
} from "../../service/environment";
import activityApi from "../../api/activity";
import qaApi from "../../api/qaModule";
import {
  shareWx,
  sharePYQ,
  pasteText,
  saveAlbum,
  sharePicture,
} from "../../environment/lk_api";
import {
  shareAnbWX,
  savImg,
  shareAnbPYQ,
  isAnb,
} from "../../environment/anb_api";
import {
  MainAppApiShareWx,
  MainAppApiSharePYQ,
  insidebrowser,
} from "../../environment/mainapp_api.js";
export default {
  components: {
    SocialHeader,
    SocialDialog,
    PullLoad,
    Share,
    SharePanel,
  },
  created: function () {
    var current = this;
    changeDocumentTitle("活动详情");
    if (isGoEnv()) {
      current.isShowShare = false;
    }
    current.cheackUserAccountState();
    current.isLoadingActivity = true;
    current.platformActivityId = this.$route.params.platformActivityId;
    let cityInfo = JSON.parse(localStorage.getItem("USER_CITY"));
    let cityId = Tools.getQueryString("cityId");
    const popupseriesid = Tools.getQueryString("popupseriesid");
    const popuptype = Tools.getQueryString("popuptype");
    const popuppvid = Tools.getQueryString("popuppvid");
    var param = {
      platformActivityId: current.platformActivityId,
      pvAreaId: this.baseInfo.pvareaId,
      cityId: cityId ? cityId : cityInfo.cityId,
      popupseriesid,
      popuptype,
      popuppvid,
    };
    current.$store.dispatch("getActivityDetail", param).then(function () {
      current.inx = current.activity.sharePostersImages.length;
      if (current.activity.id === 0) {
        Dialog.toast({
          title: "该活动已下线",
          timeout: 2000,
          callback: function () {
            window.location = "#/activity/home";
          },
        });
      }
      current.isLoadingActivity = false;
      if (current.activity) {
        current.wxMiniLink = current.activity.activityUrl;
      }
    });
    let pvAreaId = Tools.getQueryString("pvareaId");
    activityApi.getLoginComplete({ pvareaId: pvAreaId }).then((res) => {
      this.isname = false;
      this.iscode = false;
      if (res.data.returnCode === 0) {
        if (res.data.result.hasCollection) {
          this.isflagNo = true;
          this.show = true;
          const collectionFields = res.data.result.collectionFields;
          for (const field of collectionFields) {
            if (field.text === "姓名") {
              this.isname = true;
            } else if (field.text === "工号") {
              this.iscode = true;
            }
          }
        }
      }
    });
    userApi.getUserInfo({ pvareaId: this.baseInfo.pvareaId }).then((res) => {
      setTimeout(() => {
        this.getSharePosterData(res.data.result.platformAgentID);
      }, 200);
      localStorage.setItem("USER_INFO", JSON.stringify(res.data.result));
    });
    // this.agentId = JSON.parse(localStorage.getItem('USER_INFO')).platformAgentID
  },
  computed: {
    dialogShow() {
      return this.isLoadingActivity;
    },
    ...mapGetters({
      userInfo: "userInfo",
      activity: "activity",
      baseInfo: "baseInfo",
    }),
    currentEnv() {
      if (isWeiXin()) {
        return false;
      } else if (isDingDing()) {
        return false;
      } else {
        return true;
      }
    },
    isShowMask() {
      return this.isShowPoster || this.isShowShareUI;
    },
    entrance() {
      return window.entrance.name;
    },
  },
  name: "ActivityDetail",
  data: function () {
    return {
      show: false,
      isname: false,
      iscode: false,
      showFile: false,
      fileMessage: "",
      complementAgentNo: "",
      complementUserName: "",
      isLoadingActivity: true,
      isShowShareWindow: false,
      isShowShareUI: false,
      isShowAllArea: true,
      isShowAllAreaUp: false,
      loadingText: "正在加载",
      platformActivityId: 0,
      isShowShare: true, // go车隐藏分享操作
      sharePosterUrl: "", // 分享海报链接
      isShowPoster: false, // 是否展示海报
      agentId: "",
      imgss: [],
      imgs: [],
      inx: 0,
      swiper: null,
      activeIndex: 0,
      masks: false,
      columnList: [],
      columnNum: 0,
      tipText: "",
      obj: {},
      islogin: "未登录",
      wxMiniLink: "",
    };
  },
  methods: {
    isAnb() {
      return isAnb();
    },
    //分享爱农宝app微信
    shareAnbWX() {
      const { activity } = this;
      const customParams = {
        shareType: 2,
        shareToWhere: [4], // shareToWhere: [4]好友 shareToWhere: [3]朋友圈
        title: activity.activityCustomerName,
        descMsg: activity.activityRemark,
        thumbImageUrl:
          "https://j2.autoimg.cn/financedfs/g24/M0A/C8/F1/autohomecar__Chxky2Tdt2iANtLiAABI5Rq0ntU689.png",
        thumbImage64Str: "",
        linkString: activity.activityUrl,
        callBack: (res) => {
          console.log("======> ", res);
        },
      };
      shareAnbWX(customParams);
    },
    //分享爱农宝app微信朋友圈
    shareAnbPYQ() {
      const { activity } = this;
      const customParams = {
        shareType: 2,
        shareToWhere: [3], // shareToWhere: [4]好友 shareToWhere: [3]朋友圈
        title: activity.activityCustomerName,
        descMsg: activity.activityRemark,
        thumbImageUrl:
          "https://j2.autoimg.cn/financedfs/g24/M0A/C8/F1/autohomecar__Chxky2Tdt2iANtLiAABI5Rq0ntU689.png",
        thumbImage64Str: "",
        linkString: activity.activityUrl,
        callBack: (res) => {
          console.log("======> ", res);
        },
      };
      shareAnbPYQ(customParams);
    },
    //爱农宝保存本地图片
    savImg() {
      let img = this.imgs[this.activeIndex].split(",");
      console.log("---->", img[1]);
      const customParams = {
        imageBase64: img[1],
        callBack: (res) => {
          console.log("======> ", res);
        },
      };
      savImg(customParams);
      this.tipText = "图片保存成功";
      this.masks = true;
      setTimeout(() => {
        this.masks = false;
      }, 1000);
      this.closePoster();
    },
    //爱农宝复制链接
    savUrl() {
      var input = document.createElement("input");
      input.value = this.activity.activityUrl;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.tipText = "链接复制成功";
      this.masks = true;
      setTimeout(() => {
        this.masks = false;
      }, 1000);
    },
    async participate() {
      Tools.tongji("cf_shhdxq_canyuhuodong_click", this.obj, 2);
      let jumpUrl = this.activity.activityUrl;
      let pvAreaId = Tools.getQueryString("pvareaId");
      try {
        if (entrance.name == "mainapp") {
          window.location.href = insidebrowser(jumpUrl, {
            isnotwk: false,
            auto: true,
            clearLoad: true,
            transparentBg: false,
            navigationbarstyle: "0",
            animationtype: "",
            fullScreen: false,
            customshowanimationtype: "",
            disableBack: "",
            loadtype: 0,
            titlecolor: "",
            title: "",
            transparent: true,
            webviewBgcolor: "",
          });
        } else {
          let res = await activityApi.getLoginComplete({ pvareaId: pvAreaId });
          this.iscode = false;
          this.isname = false;
          if (res.data.returnCode === 0) {
            if (res.data.result.hasCollection) {
              this.show = true;
              const collectionFields = res.data.result.collectionFields;
              for (const field of collectionFields) {
                if (field.text === "姓名") {
                  this.isname = true;
                } else if (field.text === "工号") {
                  this.iscode = true;
                }
              }
            } else {
              window.location.href = jumpUrl;
            }
          } else {
            window.location.href = jumpUrl;
          }
        }
      } catch (error) {
        // 处理异步操作失败的情况
        console.error("An error occurred:", error);
      }
    },
    async submitComp() {
      const pvAreaId = Tools.getQueryString("pvareaId");
      // 检查是否有未填写的信息
      if (this.isname && this.complementUserName === "") {
        Dialog.toast({ title: "请补充信息" });
        return false;
      }
      if (this.iscode && this.complementAgentNo === "") {
        Dialog.toast({ title: "请补充信息" });
        return false;
      }
      try {
        const res = await userApi.saveComplement({
          pvareaId: pvareaId,
          complementUserName: this.complementUserName,
          complementAgentNo: this.complementAgentNo,
        });

        if (res.data.returnCode === 0) {
          Dialog.toast({ title: "补传信息成功" });
          this.show = false;
        } else {
          this.fileMessage = res.data.message;
          this.showFile = true;
          this.show = false;
        }
      } catch (error) {
        console.error("提交失败:", error);
        Dialog.toast({ title: "提交失败，请稍后重试！" });
      }
    },
    validateInputLength(input) {
      return /^.{2,30}$/.test(input);
    },
    fileClick() {
      this.showFile = false;
      this.show = true;
    },
    initSwiper() {
      this.swiper = new Swiper(".swiper-container", {
        slidesPerView: 2,
        spaceBetween: 100,
        preloadImages: 10,
        centeredSlides: true,
        effect: "coverflow",
        coverflow: {
          rotate: 15,
          stretch: 3,
          depth: 30,
          modifier: 2,
          slideShadows: false,
        },
        speed: 500,
        pagination: ".swiper-pagination",
        observer: true,
        observeParents: true,
      });
      this.swiper.on("transitionStart", () => {
        this.activeIndex = this.swiper.realIndex;
      });
    },
    hideShareWindow: function () {
      this.isShowShareWindow = false;
    },
    showAllArea: function () {
      this.isShowAllArea = true;
    },
    assertShowAllArea: function () {
      const detailTitle = document.getElementById("act-detail-area-title");
      const detailContent = document.getElementById("act-detail-area-con");
      if (detailContent && detailTitle) {
        // console.log('assert');
        if (detailContent.scrollHeight <= detailTitle.scrollHeight * 2) {
          this.isShowAllArea = false;
        }
      }
    },
    cheackUserAccountState() {
      var self = this;
      if (self.userInfo && self.userInfo.accountState === 2) {
        this.$router.replace("/account");
      }
    },
    async shareClick() {
      // this.handleShare();
      // return;
      Tools.tongji("cf_shhdxq_fenxiangzhuanqian_click", this.obj, 2);
      let pvAreaId = Tools.getQueryString("pvareaId");
      let res = await activityApi.getLoginComplete({ pvareaId: pvAreaId });
      this.iscode = false;
      this.isname = false;
      if (res.data.returnCode === 0) {
        if (res.data.result.hasCollection) {
          this.show = true;
          const collectionFields = res.data.result.collectionFields;
          for (const field of collectionFields) {
            if (field.text === "姓名") {
              this.isname = true;
            } else if (field.text === "工号") {
              this.iscode = true;
            }
          }
        } else {
          this.handleShare();
        }
      } else {
        this.handleShare();
      }
    },
    handleShare() {
      if (entrance.name == "wx" && this.activity.businessLineId == 2002) {
        this.isShowShareWindow = true;
        return
      }
      if (entrance.name == "WxMini" && this.activity.businessLineId == 2002) {
        this.isShowShareWindow = true;
        return
      }
      if (this.activity.sharePostersImages.length == 0) {
        if (entrance.name == "mainapp" && this.activity.businessLineId == 2002) {
          this.mainShareByWX();
          return
        }
      } else {
        if (this.activity.sharePostersImages.length > 0) {
          this.isLoadingActivity = true;
          this.imgss = this.activity.sharePostersImages;
          setTimeout(() => {
            this.isLoadingActivity = false;
            this.isShowPoster = true;
            Tools.tongji("cf_shhdxq_fenxianghaibao_show", this.obj, 1);
          }, 1200);
        } else {
          switch (window.entrance.name) {
            case "txh":
              this.$refs.share.shareClick();
              break;
            case "jsj":
              this.$refs.sharePanel.isShow = true;
              break;
            default:
              this.isShowShareWindow = false;
          }
        }
      }
    },
    sharePanelClick(type) {
      this.$refs.share.shareClick(type);
    },
    async copyText() {
      var text = this.$refs.aa.textContent;
      if (this.entrance == "lk") {
        pasteText(String(text));
        this.tipText = "配文复制成功";
        this.masks = true;
      } else {
        var input = document.createElement("input");
        input.value = text;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        this.tipText = "配文复制成功";
        this.masks = true;
      }
      setTimeout(() => {
        this.masks = false;
      }, 1000);
    },
    // 调用主软app分享微信
    mainShareByWX() {
      const { activity } = this;

      let shareImg;
      if (activity.businessLineId == '2002') {
        shareImg =
          "https://fs.autohome.com.cn/ahoh_views/mall/images/laxin-share.png";
      } else {
        shareImg =
          "https://j2.autoimg.cn/financedfs/g24/M0A/C8/F1/autohomecar__Chxky2Tdt2iANtLiAABI5Rq0ntU689.png";
      }
      MainAppApiShareWx({
        title: activity.activityCustomerName,
        description: activity.activityRemark,
        webpageURL: activity.activityUrl,
        iconURL: shareImg,
      });
      console.log("---->", webpageURL);
    },
    // 调用主软app分享朋友圈
    mainShareByPYQ() {
      MainAppApiSharePYQ({
        imgurl: this.imgs[this.activeIndex],
        binaryimage: this.imgs[this.activeIndex],
      });
    },
    // 调用揽客app分享微信
    shareByWX() {
      const { activity } = this;
      let shareImg =
        "https://j2.autoimg.cn/financedfs/g24/M0A/C8/F1/autohomecar__Chxky2Tdt2iANtLiAABI5Rq0ntU689.png";
      shareWx({
        title: activity.activityCustomerName,
        desc: activity.activityRemark,
        url: activity.activityUrl,
        image: shareImg,
      });
    },
    // 调用揽客app分享朋友圈
    shareByPYQ() {
      const { activity } = this;
      let shareImg =
        "https://j2.autoimg.cn/financedfs/g24/M0A/C8/F1/autohomecar__Chxky2Tdt2iANtLiAABI5Rq0ntU689.png";
      sharePYQ({
        title: activity.activityCustomerName,
        desc: activity.activityRemark,
        url: activity.activityUrl,
        image: shareImg,
      });
    },
    // 微信分享海报
    async shareByPicture() {
      sharePicture({ url: this.imgs[this.activeIndex] });
      this.closePoster();
    },
    // 保存活动链接
    async saveActivityUrl() {
      pasteText(String(this.activity.activityUrl));
      this.tipText = "链接复制成功";
      this.masks = true;
      setTimeout(() => {
        this.masks = false;
      }, 1000);
      this.closePoster();
    },
    // 保存图片到本地
    async savePosterImg() {
      let img = this.imgs[this.activeIndex].split(",");
      console.log("---->", img[1]);
      saveAlbum({ imgdata: img[1] });
      this.tipText = "图片保存成功";
      this.masks = true;
      setTimeout(() => {
        this.masks = false;
      }, 1000);
      this.closePoster();
    },
    async getSharePosterData(platformAgentID) {
      var current = this;
      let cityInfo = JSON.parse(localStorage.getItem("USER_CITY"));
      try {
        const popupseriesid = Tools.getQueryString("popupseriesid");
        const popuptype = Tools.getQueryString("popuptype");
        const popuppvid = Tools.getQueryString("popuppvid");
        for (let i = 0; i < current.inx; i++) {
          const params = {
            platformActivityId: String(current.platformActivityId),
            pvAreaId: String(current.baseInfo.pvareaId),
            platformAgentId: String(platformAgentID),
            customerId: String(current.platformActivityId),
            currentIndex: i,
            popupseriesid,
            popuptype,
            popuppvid,
            cityId: cityInfo.cityId,
          };
          try {
            const res = await activityApi.getSharePosterUrl(params);
            let blob = res.data;
            // 转换为base64
            let reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = function () {
              current.imgs.push(reader.result);
              localStorage.setItem("poster", JSON.stringify(reader.result));
            };
          } catch (error) {
            console.error("Error getting share poster URL:", error);
          }
        }
      } catch (error) {
        console.log("getPosterImg error:", error);
      }
    },
    closePoster() {
      this.isShowPoster = false;
      this.isShowShareUI = false;
    },
    async getQAContent(platformActivityId) {
      let res = await qaApi.getQAPreviewContent(platformActivityId);
      this.columnList = res.data.result;
      sessionStorage.setItem("qaContent", JSON.stringify(res.data.result));
      if (res.data.result && res.data.result.length > 0) {
        this.columnNum = res.data.result.reduce(
          (total, item) => total + item.columns.length,
          0
        );
      }
    },
    toQuestionColumn() {
      if (this.columnNum > 1) {
        this.$router.push("/activity/questionColumn");
      } else {
        sessionStorage.setItem(
          "questionActivity",
          JSON.stringify(this.columnList[0].columns[0])
        );
        this.$router.push("/activity/questionAnswer");
      }
    },
  },
  beforeMount() {
    let { platformActivityId } = this;
    this.getQAContent(platformActivityId);
    let pvAreaId = Tools.getQueryString("pvareaId");
    if (this.userInfo) {
      this.islogin = "已登录";
    }
    this.obj = {
      islogin: this.islogin,
      pvareaid: pvAreaId,
      userId: this.userInfo.platformAgentID,
      activityId: this.platformActivityId,
      businessLineId: this.activity.businessLineId,
      agentNo: this.userInfo.agentNo,
      backcard: this.userInfo.bankStatus,
    };
  },
  mounted: function () {
    this.initSwiper();
    Tools.tongji("cf_shhdxq_canyuhuodong_show", this.obj, 1);
    Tools.tongji("cf_shhdxq_fenxiangzhuanqian_show", this.obj, 1);
  },
  updated: function () {
    // console.log('update-');
    const current = this;
    Vue.nextTick(function () {
      current.assertShowAllArea();
    });
  },
  watch: {
    activity: function (val, oldVal) {
      if (val.areaCityJoinStr) {
        const current = this;
        Vue.nextTick(function () {
          current.assertShowAllArea();
        });
      }
    },
    userInfo: function (val, oldVal) {
      if (val.accountState === 2) {
        this.$router.replace("/account");
      }
    },
    activeIndex(newValue, old) {
      this.$nextTick(() => {
        console.log(this.$refs.aa.textContent);
      });
    },
  },
};
</script>
<style>
.act-detail-html ul {
  list-style: none !important;
}

.act-detail-html img {
  width: 100%;
}

.swiper-container {
  width: 100%;
  height: 22.875rem;
}

.swiper-container-padBot {
  padding-bottom: 1.125rem;
}

.swiper-pagination {
  top: 22rem;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 30000ms;
}

.swiper-slide img {
  width: 12rem;
  height: 18rem;
  border-radius: 0.625rem;
}

.swiper-slide-active img,
.swiper-slide-duplicate-active img {
  box-shadow: 0rem 0.2125rem 0.175rem rgba(0, 0, 0, 0.3);
}

.poster {
  width: 100vw;
  overflow: hidden;
  position: fixed;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 100;
  border-radius: 16px 16px 0px 0px;
  background: rgb(255, 255, 255);
}

.poster .header {
  border-radius: 1rem 1rem 0rem 0rem;
  width: 100%;
  height: 3rem;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  z-index: 100;
  border: 0.0313rem solid rgb(229, 229, 229);
}

.poster .header .title {
  width: 8.5rem;
  font-size: 1.0625rem;
  font-weight: 500;
  margin-right: 5rem;
  color: rgb(255, 107, 0);
  font-family: "PingFang SC";
  line-height: 1.125rem;
  letter-spacing: 0rem;
}

.poster .header .left {
  width: 1rem;
  font-size: 1rem;
  margin-right: 5rem;
}

.poster .swiper {
  width: 100%;
  /* height: 18.75rem; */
}

.poster .copy {
  width: 100%;
  padding: 0 1.25rem;
  height: 3.1875rem;
  display: flex;
  justify-content: space-between;
  border-radius: 0.25rem;
  margin-top: 2rem;
  box-sizing: border-box;
}

.poster .copy .left {
  width: 100%;
  height: 3.1875rem;
  white-space: nowrap;
  overflow-y: auto;
  color: rgb(17, 30, 54);
  background: rgb(248, 249, 252);
  font-family: "PingFang SC";
  font-size: 0.75rem;
  font-weight: 400;
  padding: 0.625rem;
  line-height: 1.125rem;
  letter-spacing: 0.0437rem;
  text-align: left;
  box-sizing: border-box;
}

.poster .copy .right {
  height: 3.1875rem;
  border-radius: 0rem 0.25rem 0.25rem 0;
  padding: 0 0.625rem;
  background-color: rgb(233, 235, 244);
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(17, 30, 54);
  font-family: "PingFang SC";
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 0.75rem;
  letter-spacing: 0rem;
  text-align: center;
}

.poster .copy .right .copys {
  width: 1.5rem;
  height: 2rem;
}

.poster .copy .right .copys img {
  width: 1rem;
  height: 0.9375rem;
}

.poster .copy .right img {
  width: 0.75rem;
  height: 0.875rem;
  margin-bottom: 0.375rem;
}

.poster .img {
  width: 75vw;
  height: 65vh;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.poster .img img {
  width: 100%;
  height: 100%;
}

.poster .menu-list {
  width: 13.75rem;
  height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 0.5rem;
  box-sizing: border-box;
}

.poster .menu-list .menu-item {
  width: 3.125rem;
  height: 4.375rem;
  margin: 0 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
}

.poster .menu-list .menu-icon {
  width: 3rem;
  height: 3rem;
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: #fff;
  position: relative;
}

.poster .menu-list .menu-icon img {
  width: 100%;
  height: 100%;
}

.poster .menu-list .menu-text {
  color: rgb(17, 30, 54);
  font-size: 12px;
}

.poster .menu-list .menu-item .iconfont {
  transform: scale(1.5);
}

.poster .menu-list .menu-item .icon-fuzhilianjie1 {
  transform: scale(2);
}

.share-ui {
  width: 100%;
  background: rgb(255, 255, 255);
  position: fixed;
  bottom: 0;
  border-radius: 1rem 1rem 0rem 0rem;
  z-index: 99;
}

.share-ui .menu-list {
  width: 100%;
  height: 6.875rem;
  display: flex;
}

.share-ui .menu-list .menu-item {
  width: 3.125rem;
  height: 4.375rem;
  margin: 0 1rem;
  margin-top: 1.25rem;
}

.share-ui .menu-list .menu-item img {
  width: 3.125rem;
  height: 3.125rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.share-ui .menu-list .menu-item .text {
  width: 3.125rem;
  height: 1.25rem;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.share-ui .exit {
  width: 100%;
  height: 3.125rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 0.25rem solid rgb(248, 249, 252);
}

.mask {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 50;
  background: rgba(0, 0, 0, 0.3);
}

.act-detail-role-content p {
  color: black;
  font-size: 1rem;
  letter-spacing: 0.0625rem;
}

.act-detail-role-content em {
  font-style: italic;
}

.act-detail-role-content strong {
  font-weight: bold !important;
}

.act-detail-role-content em {
  font-style: italic !important;
}

.masks {
  width: 7.9375rem;
  height: 4.0625rem;
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 500;
  transform: translate(-50%, -50%);
  border-radius: 0.5rem;
  background-color: rgba(0, 0, 0, 0.9);
  color: #ffffff;
  font-size: 0.875rem;
  text-align: center;
  line-height: 4.0625rem;
  font-family: "Roboto";
}

.close {
  width: 1.375rem;
  height: 1.375rem;
  text-align: center;
  line-height: 1.375rem;
}

.close img {
  width: 100%;
  height: 100%;
}

.question-desc {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0.8333rem 0.8333rem 0 0.8333rem;
  box-sizing: border-box;
}

.question-desc img {
  width: 100%;
  height: 100%;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.block {
  width: 17.5rem;
  /* height: 19.5rem; */
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 0.75rem;
  border-radius: 0.75rem;
  position: relative;
  padding-bottom: 1.25rem;
}

/* .wrapper::before {
  content: "";

} */
.login {
  font-family: "PingFangSC-Medium";
  font-size: 1.0625rem;
  color: #111e36;
  text-align: center;
  line-height: 1.0625rem;
  margin-top: 2rem;
  font-weight: 600;
}

.img {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 0.75rem;
  height: 0.75rem;
}

.centent {
  width: 15rem;
  height: 2.3125rem;
  font-family: " PingFangSC-Regular";
  font-size: 0.75rem;
  color: #828ca0;
  text-align: justify;
  line-height: 1.125rem;
  margin-top: 1.25rem;
}

.UM {
  width: 17.5rem;
  height: 2.25rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.75rem;
}

.account {
  font-family: "PingFangSC-Regular";
  font-size: 0.875rem;
  color: #111e36;
  letter-spacing: 0;
  line-height: 1rem;
  padding-left: 1.25rem;
  box-sizing: border-box;
}

.accounts {
  font-family: "PingFangSC-Regular";
  font-size: 0.875rem;
  color: #111e36;
  letter-spacing: 0;
  line-height: 1rem;
  padding-right: 3.6875rem;
  box-sizing: border-box;
}

.input {
  width: 10rem;
  padding-right: 3.125rem;
  margin-left: 1.25rem;
  color: #000;
}

input::placeholder {
  color: #000;
  font-size: 0.875rem;
}

.submit {
  background-image: linear-gradient(270deg, #206cfe 0%, #4c88ff 100%);
  border-radius: 0.1875rem;
  border-radius: 0.1875rem;
  width: 15rem;
  height: 2.5rem;
  font-family: "PingFangSC-Medium";
  font-size: 0.875rem;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  line-height: 2.5rem;
  margin-top: 1.3125rem;
}

.change {
  margin-top: 0.75rem;
  font-family: "PingFangSC-Regular";
  font-size: 0.8125rem;
  color: #2057ff;
  text-align: center;
  line-height: 1.25rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/detail.vue